// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".js-focus-visible :focus:not(.focus-visible) {\n  outline: 0;\n}\n::-webkit-scrollbar {\n  height: 0.5rem;\n  width: 0.5rem;\n}\n::-webkit-scrollbar-thumb {\n  background-color: #e6e6e6;\n}\n::-webkit-scrollbar-track {\n  padding: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
